fragment UserRankFields on UserRankType {
  id
  __typename
  _rowTimestamp
  userRank
  sortOrder
  _isUpdatable
  _isDeletable
}
